import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { API } from '../../lib/planConstants';

/** Inline affordability preference control, this unlock requirement previously
 *  had nowhere in the app where a student could actually set it. */
export const AffordabilityPicker = ({ done, onSaved }) => {
  const { getAuthHeader } = useAuth();
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(null);
  const [open, setOpen] = useState(!done);

  useEffect(() => {
    axios.get(`${API}/launch/affordability-options`, getAuthHeader ? getAuthHeader() : {})
      .then((r) => { setOptions(r.data.options || []); setSelected(r.data.selected || null); })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async (key) => {
    setSaving(key);
    try {
      await axios.post(`${API}/launch/affordability`, { affordability_preference: key },
        getAuthHeader ? getAuthHeader() : {});
      setSelected(key);
      toast.success('Affordability preference saved');
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not save that preference.');
    } finally {
      setSaving(null);
    }
  };

  if (done && !open) {
    return (
      <button onClick={() => setOpen(true)} className="mt-2 text-xs text-cyan-300 hover:text-cyan-200"
        data-testid="affordability-change-btn">
        Change my affordability preference
      </button>
    );
  }

  return (
    <div className="mt-3 space-y-2" data-testid="affordability-picker">
      <p className="text-xs text-slate-300">How much are you willing to borrow for your pathway?</p>
      {options.map((o) => (
        <button key={o.key} onClick={() => save(o.key)} disabled={saving}
          data-testid={`affordability-option-${o.key}`}
          className={`w-full text-left p-3 rounded-xl border transition-colors duration-200 ${
            selected === o.key ? 'border-cyan-400/60 bg-cyan-500/10' : 'border-slate-700 bg-slate-900/40 hover:border-cyan-500/40'
          }`}>
          <span className="flex items-center gap-2">
            {saving === o.key ? <Loader2 className="w-3.5 h-3.5 animate-spin text-cyan-300" />
              : selected === o.key ? <Check className="w-3.5 h-3.5 text-cyan-300" /> : null}
            <span className="text-sm text-white font-medium">{o.label}</span>
          </span>
          <span className="block text-xs text-slate-300 mt-0.5">{o.description}</span>
        </button>
      ))}
    </div>
  );
};

export default AffordabilityPicker;
